import React from 'react'

const TreatmentSlider = () => {
  return (
    <div>
      
    </div>
  )
}

export default TreatmentSlider
